"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("../category-product/index.vue"));
var _index2 = _interopRequireDefault(require("../product/index.vue"));
var InventoryPage = /*#__PURE__*/function (_Vue) {
  function InventoryPage() {
    (0, _classCallCheck2.default)(this, InventoryPage);
    return (0, _callSuper2.default)(this, InventoryPage, arguments);
  }
  (0, _inherits2.default)(InventoryPage, _Vue);
  return (0, _createClass2.default)(InventoryPage);
}(_vuePropertyDecorator.Vue);
InventoryPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProductPage: _index2.default,
    CategoryProduct: _index.default
  }
})], InventoryPage);
var _default = exports.default = InventoryPage;